export default function EntropiPro(props){


    return(<>
    
    </>)
}